import React, { ReactElement } from 'react'
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { capceTopicAreas, capceClassTypes } from 'src/v3/events/accreditations'

type FormFieldProps = {
  field: any
}

export let TopicAreaField = ({ field }: FormFieldProps): ReactElement => (
  <FormControl fullWidth required>
    <InputLabel>Topic Area</InputLabel>
    <Select
      value={field.state.value}
      label="Topic Area"
      onChange={(e) => field.handleChange(e.target.value)}
      onBlur={field.handleBlur}
      sx={{ bgcolor: 'background.paperDark' }}
    >
      {capceTopicAreas.map((area) => (
        <MenuItem key={area} value={area}>
          {area}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

export let ClassTypeField = ({ field }: FormFieldProps): ReactElement => (
  <FormControl fullWidth required>
    <InputLabel>Class Type</InputLabel>
    <Select
      value={field.state.value}
      label="Class Type"
      onChange={(e) => field.handleChange(e.target.value)}
      onBlur={field.handleBlur}
      sx={{ bgcolor: 'background.paperDark' }}
    >
      {capceClassTypes.map((type) => (
        <MenuItem key={type} value={type}>
          {type}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

export let DateField = ({
  field,
  label,
}: FormFieldProps & { label: string }): ReactElement => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      label={label}
      value={field.state.value ? dayjs(field.state.value) : null}
      onChange={(val) => {
        if (!val) {
          field.handleChange('')
        } else {
          field.handleChange(val.format('YYYY-MM-DD'))
        }
      }}
      onClose={field.handleBlur}
      slotProps={{
        textField: {
          fullWidth: true,
          sx: { bgcolor: 'background.paperDark' },
          error: field.state.meta.errors.length > 0,
          helperText: field.state.meta.errors[0],
          onBlur: field.handleBlur,
        },
      }}
    />
  </LocalizationProvider>
)

export let CourseCodeField = ({ field }: FormFieldProps): ReactElement => (
  <TextField
    label="Course Code"
    name={field.name}
    value={field.state.value}
    onChange={(e) => field.handleChange(e.target.value)}
    onBlur={field.handleBlur}
    fullWidth
    sx={{ bgcolor: 'background.paperDark' }}
  />
)

export let NotesField = ({ field }: FormFieldProps): ReactElement => (
  <TextField
    label="Notes"
    name={field.name}
    value={field.state.value}
    onChange={(e) => field.handleChange(e.target.value)}
    onBlur={field.handleBlur}
    multiline
    rows={3}
    fullWidth
    sx={{ bgcolor: 'background.paperDark' }}
    placeholder="Add any notes or comments about this pending accreditation"
  />
)

export let DateFieldsRow = ({
  children,
}: {
  children: React.ReactNode
}): ReactElement => <Box className="grid grid-cols-2 gap-4">{children}</Box>

export let DateFieldsRowThree = ({
  children,
}: {
  children: React.ReactNode
}): ReactElement => <Box className="grid grid-cols-3 gap-4">{children}</Box>
